// 映射方法名
export default {
  SET_USER_DTOKEN: "SET_USER_DTOKEN",
  SET_ACCESS_DTOKEN: "SET_ACCESS_DTOKEN",
  SET_USER_DATA: "SET_USER_DATA",
  LOGIN_OUT: "LOGIN_OUT",
  CHANGE_THEME: "CHANGE_THEME"
};